import { EnvironmentProviders, importProvidersFrom, Provider } from '@angular/core';
import { TranslationModule } from 'app/shared/directives/language/translation.module';
import {
	provideNgxWebstorage,
	withLocalStorage,
	withNgxWebstorageConfig,
	withSessionStorage,
} from 'ngx-webstorage';

export const provideCore = (): Array<Provider | EnvironmentProviders> => {
	return [
		provideNgxWebstorage(
			withNgxWebstorageConfig({ prefix: 'vibra-stop', separator: ':', caseSensitive: true }),
			withLocalStorage(),
			withSessionStorage()
		),
		importProvidersFrom([TranslationModule]),
	];
};
